import { PlanModelInfo, planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';

export default (planMapJSON) => {
  return defaultMapper(planMapJSON['zmailcal'], planTypes.ZOOM_EMAIL_CALENDAR).map((p) => {
    return {
      ...p,
      category: 'zmailcal',
      typeNameKey: 'billing.zoom_email_calendar.title',
      planNameKey: 'billing.zoom_email_calendar.title',
      unit: planUnitMap.user,
      planModel: PlanModelInfo.license,
    };
  });
};
